// Auth - 인증 관리
export const AUTH_ENDPOINT = {
    EDIT_PW: '/auth/edit/pw',
    FIND_PW: '/auth/find/pw',
    CONFIRM_PW: '/auth/confirm/pw',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    CHECK_MAIL: '/auth/mail/check',
    SEND_MAIL: '/auth/mail/send',
    REGISTER: '/auth/register',
}

// 메인화면 혹은 기타
export const MAIN_ENDPOINT = {
    ISLAND: '/main/island',
    ISLAND_LIST: '/main/island/list',
    DASHBOARD: '/main/dashboard',
    LOG: '/main/log',
}
// File - 파일 관리
export const FILE_ENDPOINT = {
    UPLOAD: '/file/upload',
}

// Program - 교육 실적 관리
export const PROGRAM_ENDPOINT = {
    LIST: '/program/list',
    DETAIL: id => `/program/${id}`,
    CREATE: '/program/create',
    EDIT: id => `/program/${id}`,
    DELETE: id => `/program/${id}`,
}

// Tutor - 강사 관리
export const TUTOR_ENDPOINT = {
    LIST: '/tutor/list',
    LIST_REGION: '/tutor/list/region',
    DETAIL: id => `/tutor/${id}`,
    CREATE: '/tutor/create',
    EDIT: id => `/tutor/${id}`,
    DELETE: id => `/tutor/${id}`,
    VALID: '/tutor/valid',
}

// Statistic - 성과 분석
export const STATISTIC_ENDPOINT = {
    LIST: '/statistic',
    STUDENT: '/statistic/student',
    TUTOR: '/statistic/tutor',
}

// INVENTORY - 자산 관리
export const INVENTORY_ENDPOINT = {
    LIST: '/tools/list',
    CONFIRM: '/tools/confirm',
    DETAIL: id => `/tools/${id}`,
    CREATE: '/tools/create',
    DELETE: id => `/tools/${id}`,
    EDIT: id => `/tools/${id}`,
}

// Rental - 대여 반납
export const RENTAL_ENDPOINT = {
    LIST: '/rental/list',
    DETAIL: id => `/rental/${id}`,
    CREATE: '/rental/create',
    DELETE: id => `/rental/${id}`,
    EDIT: id => `/rental/${id}`,
    INVENTORY: '/rental/inventory',
    CHANGE_STATE: '/rental/state',
    VALID: '/rental/valid',
    GRID: '/rental/grid',
}

// Survey - 수요조사 관리
export const SURVEY_ENDPOINT = {
    REQ_DETAIL: id => `/survey/req/${id}`,
    REQ_DELETE: id => `/survey/req/${id}`,
    REQ_EDIT: id => `/survey/req/${id}`,
    REQ_CREATE: '/survey/req/create',
    REQ_LIST: '/survey/req/list',
    RES_DETAIL: id => `/survey/res/${id}`,
    RES_CREATE: '/survey/res/create',
    RES_LIST: '/survey/res/list',
    RES_SELECT: (id, status) => `/survey/res/select/${id}/${status}`,
    SUBMIT: uuid => `/survey/submit/${uuid}`,
}

// Report - 월간보고 관리
export const REPORT_ENDPOINT = {
    LIST: '/report/list',
    DETAIL: id => `/report/${id}`,
    CREATE: '/report/create',
    EDIT: id => `/report/${id}`,
    DELETE: id => `/report/${id}`,
    CALCULATE: '/report/calculate',
}

// Notice - 공지사항
export const NOTICE_ENDPOINT = {
    LIST: '/notice/list',
    DETAIL: id => `/notice/${id}`,
    CREATE: '/notice/create',
    EDIT: id => `/notice/${id}`,
}
// FAQ - 자주하는질문
export const FAQ_ENDPOINT = {
    LIST: '/faq/list',
    DETAIL: id => `/faq/${id}`,
    CREATE: '/faq/create',
    EDIT: id => `/faq/${id}`,
}
// Contact - 문의 관리
export const CONTACT_ENDPOINT = {
    LIST: '/contact/list',
    DETAIL: id => `/contact/${id}`,
    CREATE: '/contact/create',
    ANSWER: '/contact/answer',
    DELETE: id => `/contact/${id}`,
}

// AI - 자연어 검색 / 지역 비교
export const AI_ENDPOINT = {
    SEARCH: '/ai/search',
    COMPARE: '/ai/compare',
}

// DEV - 프롬프트 관리 (dev 전용)
export const PROMPT_ENDPOINT = {
    LIST: '/dev/prompt',
    DETAIL: id => `/dev/prompt/${id}`,
    CREATE: '/dev/prompt',
    EDIT: id => `/dev/prompt/${id}`,
    DELETE: id => `/dev/prompt/${id}`,
    TEST: id => `/dev/prompt/${id}/test`,
}

// User - 계정 관리
export const USER_ENDPOINT = {
    LIST: '/user/list',
    DETAIL: userId => `/user/${userId}`,
    REGISTER: '/user/register',
    DELETE: userId => `/user/${userId}`,
    MYPAGE: '/user/mypage',
}
